import React, { useState } from "react";
import "./EmbeddedCheckout.css";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { routeName } from "Service/env";
import * as constants from "Constants";

function EmbeddedCheckout({ eventUserEvents }) {
    const [appearance, setAppearance] = useState("modal");
    const [modalOpen, setModalOpen] = useState(false);
    const [copySuccess, setCopySuccess] = useState("");

    const eventId = eventUserEvents?.eventsAbout?.EventId || "";
    const eventUrl = `${constants.URLs.hostName+routeName}/event/${eventId}?embed=true`;

    const embedCode = getEmbedCode(appearance, eventUrl);

    const handleCopyCode = async () => {
        try {
            await navigator.clipboard.writeText(embedCode.trim());
            setCopySuccess("Copied!");
        } catch {
            setCopySuccess("Failed to copy!");
        }
        setTimeout(() => setCopySuccess(""), 2000);
    };

    if (!eventUserEvents?.eventPublish) {
        return <Redirect to={`${routeName}/Dashboard/Publish`} />;
    }

    return (
        <div className="embeddedCheckout">
            <div className="email_invite_wrapper">
                <div className="email_invite_header">
                    <div className="email_invite">
                        <span style={{ fontSize: 30 }}>Embedded Checkout</span>
                    </div>
                </div>
            </div>

            <div className="checkout-appearance">
                {/* Appearance Selector */}
                <p className="select-checkout-appearance">
                    Select Your White-Label Checkout Appearance
                </p>
                <p className="select-checkout-appearance-description">
                    Use snippet below to add white-label checkout to sell tickets directly on your website.
                </p>
                <div>
                    {["modal", "embedded"].map((type) => (
                        <label key={type}>
                            <input
                                type="radio"
                                value={type}
                                checked={appearance === type}
                                onChange={() => setAppearance(type)}
                            />
                            {type === "modal"
                                ? "A button that overlays a modal window on the page"
                                : "Embedded within the content on the page"}
                        </label>
                    ))}
                </div>

                {/* Preview */}
                <div className="preview">
                    {appearance === "modal" ? (
                        <>
                            <button style={styles.buyButton} onClick={() => setModalOpen(true)}>
                                Buy Tickets
                            </button>
                            {modalOpen && (
                                <Modal onClose={() => setModalOpen(false)}>
                                    <iframe src={eventUrl} style={styles.iframeModal}></iframe>
                                </Modal>
                            )}
                        </>
                    ) : (
                        <iframe src={eventUrl} style={styles.iframeEmbedded}></iframe>
                    )}
                </div>

                {/* Embed Code */}
                <div className="embed-code">
                    <p>Paste this snippet into your website:</p>
                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{embedCode}</pre>
                    <div style={{ marginBottom: "40px" }}>
                        <button className="copy-code" onClick={handleCopyCode}>
                            Copy code
                        </button>
                        {copySuccess && (
                            <span style={{ color: "green", marginLeft: 10 }}>{copySuccess}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// Modal Component
const Modal = ({ onClose, children }) => (
    <div style={styles.popupOverlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
        <div style={styles.popupContent}>
            <button style={styles.closeButton} onClick={onClose}>
                <svg viewBox="0 0 512 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
                        fill="black"
                        stroke="black"
                    />
                </svg>
            </button>
            {children}
        </div>
    </div>
);

// Generate Embed Code
const getEmbedCode = (appearance, eventUrl) => {
    // Fallback link if JS is disabled
    const noScriptModal = `<noscript><a 
                            href="${eventUrl}" 
                            target="_blank" 
                            rel="noopener noreferrer">Buy Tickets</a></noscript>`;

    if (appearance === "modal") {
        const popupId = "popup_" + Date.now() + "_" + Math.floor(Math.random() * 10000);

        return `${noScriptModal}<div 
            style="display:flex; 
            justify-content:center;"><button 
            data-ubme-type="popup" 
            data-ubme-url="${eventUrl}" 
            data-ubme-width="900px" 
            data-ubme-height="600px" style="${inlineStyles.button}">Buy Tickets</button></div><script src="${constants.URLs.hostName+routeName}/embed.js" defer></script>`;
    }

    const noScriptInline = `<noscript><a 
                    href="${eventUrl}" 
                    target="_blank" 
                    rel="noopener noreferrer">View Event & Buy Tickets</a></noscript>`;

    return `${noScriptInline}<div 
            class="ubme-embed" 
            data-ubme-type="inline" 
            data-ubme-url="${eventUrl}" 
            data-ubme-width="100%" 
            data-ubme-height="750px"></div><script src="${constants.URLs.hostName+routeName}/embed.js" defer></script>`;
};




// Inline styles for embed code
const inlineStyles = {
    button: "background-color:#851679; color:#fff; width:150px; height:50px; border:none; cursor:pointer; font-size:16px; font-weight:200; border-radius:25px;",
    overlay: "display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); justify-content:center; align-items:center; z-index:1000000000;",
    content: "position:relative; background:#fff; width:100%; max-width:850px; z-index:10000;",
    close: "all:unset; position:absolute; top:7px; right:7px; background-color:rgba(248, 247, 250, 0.65); border-radius:50%; border:none; cursor:pointer; height:40px; width:40px; display:flex; justify-content: center; align-items: center;"
};

// React styles
const styles = {
    buyButton: { backgroundColor: "#851679", color: "#fff", width: "150px", height: "50px", border: "none", cursor: "pointer", fontSize: "16px", fontWeight: "200", borderRadius: "25px" },
    popupOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000000000 },
    popupContent: { position: "relative", background: "#fff", width: "100%", maxWidth: "850px" },
    closeButton: { all:"unset", position: "absolute", top: "7px", right: "7px", backgroundColor: "rgba(248, 247, 250, 0.65)", borderRadius: "50%", border: "none", cursor: "pointer", height: "40px", width:"40px", display: "flex", justifyContent: "center", alignItems: "center"},
    iframeModal: { width: "100%", height: "600px", border: "none" },
    iframeEmbedded: { width: "100%", height: "750px", border: "none" }
};

export default connect(({ eventUserEvents }) => ({ eventUserEvents }))(EmbeddedCheckout);
